export const PERMISSIONS: Record<string, string[]> = {
  owner: ['users.invite', 'clients.delete'],
  user: [],
};

// Optional minimal type so can() can accept anything with a role
export interface UserLike {
  role?: string | null;
}
